var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSendingEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9541 57.4546H22.0452C20.927 57.4546 20.1816 58.2002 20.1816 59.3182C20.1816 60.4362 20.9272 61.1818 22.0452 61.1818H36.9543C38.0725 61.1818 38.8178 60.4362 38.8178 59.3182C38.8178 58.2002 38.0723 57.4546 36.9541 57.4546Z",
    fill: "#344054",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3639 48.1366H16.4549C15.3367 48.1366 14.5913 48.8821 14.5913 50.0001C14.5913 51.1182 15.3368 51.8637 16.4549 51.8637H31.3639C32.4821 51.8637 33.2275 51.1182 33.2275 50.0001C33.2275 48.8821 32.4821 48.1366 31.3639 48.1366Z",
    fill: "#344054",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7726 38.8184H10.8636C9.74552 38.8184 9 39.5638 9 40.682C9 41.8002 9.74552 42.5456 10.8636 42.5456H25.7726C26.8908 42.5456 27.6362 41.8 27.6362 40.682C27.6362 39.5639 26.8908 38.8184 25.7726 38.8184Z",
    fill: "#344054",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1721 33.9729C82.6129 33.2274 81.3085 33.0411 80.563 33.6002L60.8085 48.6957C58.7586 50.1866 55.963 50.1866 53.913 48.6957L34.1586 33.6002C33.4131 33.0411 32.1086 33.0411 31.5495 33.9729C30.9904 34.7184 30.9904 36.0229 31.9222 36.582L51.863 51.6775C53.5404 52.9819 55.5904 53.541 57.4539 53.541C59.3175 53.541 61.5539 52.9819 63.0448 51.6775L82.7994 36.582C83.5449 36.0229 83.7312 34.7184 83.1721 33.9729Z",
    fill: "#344054",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.409 25.7729H25.7728C24.6545 25.7729 23.9092 26.5184 23.9092 27.6365C23.9092 28.7545 24.6545 29.5002 25.7728 29.5002H85.409C86.5272 29.5002 87.2725 30.2458 87.2725 31.3638V68.6364C87.2725 69.7546 86.527 70.4999 85.409 70.4999H25.7728C24.6545 70.4999 23.9092 71.2455 23.9092 72.3635C23.9092 73.4817 24.6547 74.2271 25.7728 74.2271H85.409C88.5772 74.2271 90.9998 71.8044 90.9998 68.6362V31.3638C90.9998 28.1958 88.5772 25.7729 85.409 25.7729Z",
    fill: "#344054",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9862 63.6046L71.8045 52.4228C71.0589 51.6773 69.9409 51.6773 69.1954 52.4228C68.4498 53.1683 68.4498 54.2864 69.1954 55.0319L80.3771 66.2137C80.7498 66.5863 81.3089 66.7728 81.6816 66.7728C82.0543 66.7728 82.6134 66.5863 82.9862 66.2137C83.7316 65.4683 83.7316 64.3501 82.9862 63.6046Z",
    fill: "#344054",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendingEmail);
export default __webpack_public_path__ + "static/media/icon_sending_email.3cb3fa5e06158f6b009091897a8d42b4.svg";
export { ForwardRef as ReactComponent };